export default __webpack_public_path__ + "static/media/X.d725ce46.svg";